<template>
    <div>
        <l-card-headline>
            {{ $t("profile.goals.titleVisitor") }}
        </l-card-headline>

        <div class="tw-pt-8">
            <l-skeleton-loader v-if="isLoading" />

            <div v-else-if="!goals.length" class="tw-text-gray-400">
                {{ $t("profile.goals.emptyVisitor", { firstname: user.firstname }) }}
            </div>

            <l-goals-list v-else :goals="goals" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LCardHeadline from "@/components/LCardHeadline";
import LSkeletonLoader from "@/components/LSkeletonLoader";
import LGoalsList from "@/components/LUserProfile/LGoalsList";

export default {
    components: {
        LCardHeadline,
        LSkeletonLoader,
        LGoalsList,
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            isLoading: true,
            tabs: [
                {
                    id: "my",
                    label: this.$t("profile.goals.labelActive"),
                },
            ],
        };
    },
    computed: {
        ...mapGetters({
            goals: "goals/goals/list",
        }),
    },
    async mounted() {
        try {
            await this.$store.dispatch("goals/goals/getList", {
                payload: {
                    listCustomFilter: { users: [this.user._id] },
                    listSegment: "custom",
                    output: "profile",
                },
            });
        } finally {
            this.isLoading = false;
        }
    },
    methods: {},
};
</script>
